import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useNotNullableContext } from '../../hooks';
import clientConfig from '../../client/config';
import { PageMetaContext } from '../../context';
import classnames from 'classnames';

type InMemoryCreateFundraisingPageButtonProps = {
  firstNameOfDeceased?: string;
  className?: string;
  trackingIdentifier?: string;
};

export const InMemoryCreateFundraisingPageButton: FunctionComponent<InMemoryCreateFundraisingPageButtonProps> = ({
  firstNameOfDeceased,
  className,
  trackingIdentifier,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });
  const { pageSlug } = useNotNullableContext(PageMetaContext);

  const createFrpUrl = `${clientConfig.baseUri}/fundraising-page/creation/initiate?rmpId=${pageSlug}`;

  const makeAPageButtonLabel =
    firstNameOfDeceased && firstNameOfDeceased.length <= 16
      ? `${t('inMemory.cta.makeAPageFor')} ${firstNameOfDeceased}`
      : t('inMemory.cta.makeAPageInMemory');

  return (
    <a
      href={createFrpUrl}
      className={classnames('jg-btn', className)}
      data-track={trackingIdentifier}
    >
      {makeAPageButtonLabel}
    </a>
  );
};
